<template>
  <a-card class="style1">
    <a-button type="primary" class="mb-3" @click="$router.push({ name: 'AdminCreateCategoryAnswer', params: { categorySlug: $route.params.categorySlug } })">Create answer</a-button>
    <a-table :loading="isLoading" :columns="columns" :data-source="answerData" size="middle" bordered rowKey="id">
      <div slot="title" slot-scope="record">
        <a href="javascript:;" @click="onEdit(record)">{{ record.title }}</a>
      </div>
      <div slot="action" slot-scope="record" class="action">
        <a href="javascript:;" @click="onEdit(record)">Edit</a>
        <a-popconfirm title="Are you sure？" ok-text="Yes" cancel-text="No" @confirm="onDelete(record)">
          <a href="javascript:;">Delete</a>
        </a-popconfirm>
      </div>
      <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px;">
        <a-input
          v-ant-ref="c => (searchInput = c)"
          :placeholder="`Search ${column.title}`"
          :value="selectedKeys[0]"
          style="width: 190px; margin-bottom: 8px; display: block;"
          @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => handleSearch(selectedKeys, confirm, column.key)"
        />
        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px;" @click="() => handleSearch(selectedKeys, confirm, column.key)">Search</a-button>
        <a-button size="small" style="width: 90px;" @click="() => handleReset(clearFilters)">Reset</a-button>
      </div>
      <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
    </a-table>
  </a-card>
</template>
<script>
import { slugData, empty } from '@/utils';
import AdminService from '@/services/AdminService';
import { includes } from 'lodash';
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      form: this.$form.createForm(this),
      error: '',
      isLoading: false,
      isVisibleModal: false,
      answerData: [],
      answerEdit: {},
      columns: [
        {
          title: 'Title',
          key: 'title',
          scopedSlots: {
            customRender: 'title',
          },
        },
        {
          title: 'Type',
          dataIndex: 'answertype',
          key: 'answertype',
          width: 100,
        },
        {
          title: 'Action',
          key: 'operation',
          fixed: 'right',
          width: 100,
          scopedSlots: { customRender: 'action' },
        },
      ].map(item => {
        if (item.key !== 'operation') {
          return {
            ...item,
            scopedSlots: {
              ...item.scopedSlots,
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
            },
            onFilter: (value, record) => record[this.searchedColumn] && includes(slugData(record[this.searchedColumn]), slugData(value)),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus();
                }, 0);
              }
            },
          };
        }
        return item;
      }),
    };
  },
  watch: {
    data: {
      async handler(val) {
        this.answerData = val;
      },
      immediate: true,
    },
  },

  methods: {
    empty,
    onEdit(record) {
      this.$router.push({
        name: 'AdminCategoryAnswerDetail',
        params: {
          categorySlug: this.$route.params.categorySlug,
          answerSlug: record.slug,
        },
      });
    },
    async onDelete(record) {
      try {
        this.isLoading = true;
        await AdminService.answer.delete(record.id);
        this.$notification['success']({
          message: 'Delete successful.',
          description: `${record.title} was deleted successfully.`,
        });
        this.$emit('onDelete');
      } catch (error) {
        console.error({ error });
      } finally {
        this.isLoading = false;
      }
    },
    handleSearch(selectedKeys, confirm, key) {
      confirm();
      this.searchedColumn = key;
    },

    handleReset(clearFilters) {
      clearFilters();
    },
  },
};
</script>
